import { AssistantContext } from '~/steps/steps';
import { ProductRequest } from '@/lib/submit/send-product-request';

export const getProductRequest = (
  assistantContext: AssistantContext,
  comment: string,
  productId: string,
  productType: string | null,
  assistantData: Record<string, unknown>,
  salutation?: 'Herr' | 'Frau' | 'Keine Angabe',
): ProductRequest => {
  const contactFormData = assistantContext.contactForm;

  return {
    city: contactFormData.city,
    comment,
    email: contactFormData.email,
    firstName: contactFormData.firstname,
    lastName: contactFormData.lastname,
    phone: contactFormData.phone,
    productId,
    requestType: productType,
    productUrl: `${process.env.VUE_APP_STAWAG_HOST}/detail/${productId}`,
    salutationDisplayName: salutation ?? 'Keine Angabe',
    street: `${contactFormData.street} ${contactFormData.streetNumber}`,
    zipCode: contactFormData.zipcode,
    assistantData,
  };
};
